import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=f49bc522&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f49bc522')) {
      api.createRecord('f49bc522', component.options)
    } else {
      api.reload('f49bc522', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=f49bc522&", function () {
      api.rerender('f49bc522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zkBf8K3p8CQo/JS/pricehelp.vue"
export default component.exports